import { UnknownError } from '@cian/peperrors/shared';

import { TDeleteOfferFromComparisonResponse } from 'shared/repositories/offers-comparison/v1/delete-offer-from-comparison';
import { getErrorMessage } from 'shared/utils/getErrorMessage';

export const assertUnknownError = (response: TDeleteOfferFromComparisonResponse): void => {
  if (response.statusCode !== 400) {
    return;
  }

  const { message, errors } = response.response;

  throw new UnknownError({
    domain: 'src/shared/services/offersComparison/deleteOfferFromComparison.ts',
    message: getErrorMessage(message),
    details: {
      errors: typeof errors === 'object' && JSON.stringify(errors),
    },
  });
};
